<template>
  <section class="schools">
    <div class="grid center gap-3 lg-grid-cols-4 sm-grid-cols-3 xs-grid-cols-1">
      <div class="flex vertical left" v-for="(item, i) in schools" :key="i">
        <div class="text-center">{{ item.type }} Schools</div>
        <mvtCardSchool v-for="school in item.list" :data="school" :key="school.uId" :options="schoolCardOptions"></mvtCardSchool>
      </div>
    </div>
    <div class="f7 m-t-1">Source: <a class="link" href="http://greatschools.org/" rel="nofollow" target="_blank">GreatSchools.org</a> © {{new Date().getFullYear()}}. All rights reserved.</div>
  </section>
</template>

<script>
  import mvtDropdownList from '@/common/components/mvtdropdownlist/mvt-dropdownlist.vue';
  import mvtCardSchool from '@/common/components/mvtcardschool/mvt-cardschool.vue';

  export default {
    name: 'exploreSchools',
    components: {
      mvtDropdownList,
      mvtCardSchool,
    },
    props: {
      schools: {
          type: Array,
          required: true,
          default: ()=> {
            return []
          }
      },
    },
    data() {
        return {
            schoolCardOptions: { hideFooter: false }
        };
    },
  };
</script>